import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const MARK_NOTIFICATION_READ = gql`
  ${NOTIFICATION_FIELDS}
  mutation markNotificationRead($id: ID!) {
    markNotificationRead(id: $id) {
      ...NotificationFields
    }
  }
`
